import React from "react";
import I18n from "../../../../commons/I18n/I18n";
import ParkingMeter from "../../../../commons/model/ParkingMeter";
import { generateRoute } from "../../../../commons/utils/Router";
import Th from "../../../../components/table/Th";
import I18nKeys from "../../../../I18n/I18nKeys";
import { ROUTE_COMPANY_USER_PARKING_METER_DETAIL } from "../../../../routing/Routes";
import { goToRoute } from "../../../../utils/Router";
import { OnSortHandler, SortState } from "../../../../utils/Sort";

interface ParkingMeterListTableProps {
    data: ParkingMeter[];
    error: string;
    onSort: OnSortHandler;
    sort: SortState;
    renderSelectTd?: (itemId: string)=> React.ReactNode;
}

const goToItemDetail = (itemId: string): void => {
  goToRoute(generateRoute(ROUTE_COMPANY_USER_PARKING_METER_DETAIL, {
    id: itemId,
  } ));
};

export default class ParkingMeterListTable extends React.Component<ParkingMeterListTableProps> {
  public render(): React.ReactNode {
    const {data, renderSelectTd} = this.props;

    return (
      <table className="table table-hover">
        <thead>{this.renderTH()}</thead>
        <tfoot>{this.renderTH()}</tfoot>
        <tbody>
          {data && data.map((parkingMeter: ParkingMeter) => (
            <tr key={parkingMeter.id}
              onClick={() => goToItemDetail(parkingMeter.id)}
              className={"tr-cursor"}
            >
              {renderSelectTd ? renderSelectTd(parkingMeter.id) : null}
              <td>
                {parkingMeter.code}
              </td>
              <td>
                {parkingMeter.places}
              </td>
              <td>
                {parkingMeter.description}
              </td>
              <td>
                {parkingMeter.type}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  private renderTH(): React.ReactNode {
    const {sort, children, onSort} = this.props;
    const commonProps = {
      sort,
      onSort,
    };

    return (
      <tr>
        {children}
        <Th text={I18n.tr(I18nKeys.CODIGO)}
          columnName={"code"}
          {...commonProps}
        />
        <Th text={I18n.tr(I18nKeys.N_PLAZAS)}
          columnName={"code"}
          {...commonProps}
        />
        <Th text={I18n.tr(I18nKeys.DESCRIPCION)}
          columnName={"description"}
          {...commonProps}
        />
        <Th text={I18n.tr(I18nKeys.TIPO)}
          columnName={"type"}
          {...commonProps}
        />
      </tr>
    );
  }
}
